import useMeasure from 'react-use-measure'
import cn from 'clsx'
import { a, useSpring } from '@react-spring/web'

interface RadioDropdownProps {
  title: string
  children: React.ReactNode
  toggled: boolean
  onClick: () => void
}

const RadioDropdown = ({
  title,
  children,
  toggled,
  onClick,
}: RadioDropdownProps) => {
  const [ref, { height: viewHeight }] = useMeasure()

  const animProps = useSpring({
    height: toggled ? viewHeight : 0,
    config: { tension: 250, friction: 32, clamp: true, duration: 150 },
    opacity: toggled ? 1 : 0,
  })

  const chevronRotation = toggled ? '-rotate-90' : 'rotate-90'
  const blackBg = toggled ? '' : 'bg-black/30'

  return (
    <div className={cn(blackBg, 'py-4 px-5 border border-deepPurple w-full')}>
      <button onClick={onClick} className="w-full">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="border border-deepPurple w-5 h-5 rounded-full mr-4">
              {toggled && (
                <div className="w-3 h-3 rounded-full bg-white m-[3px]" />
              )}
            </div>
            <div className="font-bold">{title}</div>
          </div>
          <div className={cn(chevronRotation, 'justify-self-end')}>{'>'}</div>
        </div>
      </button>
      <a.div style={{ overflow: 'hidden', ...animProps }}>
        <div ref={ref}>{children}</div>
      </a.div>
    </div>
  )
}

export default RadioDropdown
